import React from 'react';

import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import {
  AutorestartFields,
  TimestampFields,
} from '@vlabs/monokit/entities/sources';
import { FormFieldGroup } from '@vlabs/monokit/shared/ui/form-field-group';

import { useSourceGroupStreamSettingsTranslation } from './i18n';
import st from './SourceGroupStreamSettings.module.sass';
import type { GroupSettingsFormValues } from '../source-group-general-info';

function SourceGroupStreamSettings(): React.JSX.Element {
  const { t } = useSourceGroupStreamSettingsTranslation();
  const { control } = useFormContext<GroupSettingsFormValues>();

  return (
    <div className={st.Root}>
      <div className={st.Section}>
        <h3 className={st.SectionTitle}>{t('data_title')}</h3>

        <FormFieldGroup>
          <TimestampFields namePrefix="stream_settings.data" />
        </FormFieldGroup>
      </div>

      <div className={st.Section}>
        <h3 className={st.SectionTitle}>{t('autorestart_title')}</h3>

        <FormFieldGroup>
          <FormFieldGroup.Item label={t('fields.restart')}>
            <Control.Switch
              control={control}
              name="stream_settings.autorestart.restart"
            />
          </FormFieldGroup.Item>

          <AutorestartFields namePrefix="stream_settings.autorestart" />
        </FormFieldGroup>
      </div>
    </div>
  );
}

export { SourceGroupStreamSettings };
